exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal[data-v-0cb2c31e] {\n    font-size: 18px;\n}\n.modal-content[data-v-0cb2c31e] {\n    max-height: 80%;\n}\n", ""]);

// exports
